import { useEffect, useState } from "react";
import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
  getGridStringOperators,
} from "@mui/x-data-grid";
import styled from "styled-components";
import { Typography, Button, IconButton, Stack, Select, Medium, MenuItem, Modal, Box } from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import CloseIcon from '@mui/icons-material/Close';
import Tooltip from "@mui/material/Tooltip";
import { Add } from "@mui/icons-material";
import OpaqueLoading from "../../components/opaqueLoading/opaqueLoading";
import AddTransporterModal from "../../components/modals/addTransporterModal";
import DeleteIcon from "@mui/icons-material/Delete";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import BulkAddTransporter from "../../components/modals/BulkAddTransporter";
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
const isMobile = window.innerWidth < 900;

const StaffEditorPageContainer = styled.div`
  height: ${isMobile ? `auto` : `calc(100vh - 105px)`};
  width: 100%;
  background-color: white;
  padding: 10px 15px;
  ${isMobile && `position: relative;`}
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${isMobile ? "flex-start" : "space-between"};
  margin-bottom: 10px;
  flex-direction: ${isMobile ? "column" : "row"};
`;

const TableContainer = styled.div`
  width: 100%;
  border-radius: 8px;
`;

const DataGridContainer = styled.div`
  max-width: 100%;
  margin: 0 auto;
  width: 100%;
  border: solid 1px lightGrey;
  border-radius: 8px;
  display: ${isMobile ? "flex" : "grid"};
  ${isMobile &&
  `
    flex-direction: column;
  `}
`;

export default function TransporterManagement() {

  const [loading, setLoading] = useState(false);
  const [accessChanges, setAccessChanges] = useState("");
  const [transporterModal, setTransporterModal] = useState(false);
  const [editTransporterModal, setEditTransporterModal] = useState(false);
  const [dataModal, setDataModal] = useState();
  const [rowCount, setRowCount] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [bulkTransporter, setBulkTransporter] = useState(false)
  const [selectedTab, setSelectedTab] = useState(0);
  const [expenseModalData, setExpenseModalData] = useState({});
  const [openExpenseViewModal, setOpenExpenseViewModal] = useState(false);
  const [paginationModel, setPaginationModel] = useState({
    page: currentPage - 1,
    pageSize: 20,
  });
    const [accessModulesData, setAccessModulesData] = useState([]);
        const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)


    useEffect(()=>{
        fetchAccessModules();
    },[])

  useEffect(() => {
    getTransporters();
  }, [paginationModel.page, paginationModel.pageSize]);

  const formatTimeStamp = (timestampFromDB) => {
    const options = {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };

    const formattedDate = new Date(timestampFromDB).toLocaleString(
      "en-US",
      options
    );
    return formattedDate;
  };

  const getTransporters = async () => {
    try {
      setLoading(true);
      let results = await window.Platform.database.getTransporters({ pageNumber: paginationModel.page, recordPerPage: paginationModel.pageSize });
      setRowCount(results.data1);

      const jsonArrayWithId = results?.data?.map((obj, index) => ({
        ...obj,
        id: index + 1,
      }));

      setAccessChanges(jsonArrayWithId);
      setLoading(false);
    } catch (error) {
      window.NotificationUtils.showError("Session Expired Please LogIn Again" || "Error Fetching Data");
      setLoading(false);
    }
  };

  // const deleteTransporter = async (item) => {
  //   try {
  //     setLoading(true);
  //     await window.Platform.database.deleteTransporter({ id: item.transporterId });
  //     getTransporters();
  //     setLoading(false);
  //     window.NotificationUtils.showSuccess("Transporter deleted successfully!");
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

   const fetchAccessModules = async () => {
        try {
            setLoading(true);
            let data = {
                pageNumber: paginationModel.page,
                recordPerPage: paginationModel.pageSize,
                userId : userData?.id,
                moduleId : "dApt1Uoici"
            }
            let results = await window.Platform.database.fetchAccessModules(data);
            if (results?.status) {
                window.NotificationUtils.showError(results?.message || "Something went wrong");
                setLoading(false);
                return;
            }
            else {
                const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, idIndex: index + 1 }));
                setAccessModulesData(jsonArrayWithId);
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false)
        }
    }
  const deleteTransporter = async (item) => {
    try {
      const confirmation = window.confirm(`Are you sure you want to delete transporter ?`);
      if (confirmation) {
        setLoading(true);
        await window.Platform.database.deleteTransporter({ id: item.transporterId });
        getTransporters();
        setLoading(false);
        window.NotificationUtils.showSuccess("Transporter deleted successfully!");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleOpenExpenseModal = (data) => {
    setExpenseModalData(data)
    setOpenExpenseViewModal(true)
  }

  const handleCloseExpenseViewModal = () => {
    setOpenExpenseViewModal(false);
    setExpenseModalData({})
  };

  const handleEdit = (data) => {
    setDataModal(data);
    setEditTransporterModal(true);
    setTransporterModal(false);
  };

  const getTransporterColumns = () => {
    const stringOperators = getGridStringOperators().filter((op) =>
      ["contains"].includes(op.value)
    );
    let result = [
      {
        field: "transporterName",
        headerName: "Transporter Name",
        sortable: false,
        width: 200,
        filterOperators: stringOperators,
        editable: false,
        valueGetter: (params) => {
          return (params.row?.transporter_name.split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(" ") || "N/A");
        },
        renderCell: (params) => {
          let transporterName = params.row?.transporter_name.split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(" ") || "N/A";
          return (
            <Tooltip title={transporterName || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{transporterName}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "contactPersonName",
        headerName: "Contact Person Name ",
        width: 200,
        filterable: true,
        sortable: false,
        valueGetter: (params) => {
          return (params.row?.contact_person_name || "N/A");
        },
        renderCell: (params) => {
          let contactPersonName = params.row.contact_person_name || "N/A";
          return (
            <Tooltip title={contactPersonName || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{contactPersonName}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "contactPersonNumber",
        headerName: "Contact Person Number",
        width: 200,
        filterable: true,
        sortable: false,
        valueGetter: (params) => {
          return (params.row?.contact_person_number || "N/A");
        },
        renderCell: (params) => {
          let contactPersonNumber = params.row.contact_person_number || "N/A";
          return (
            <Tooltip title={contactPersonNumber || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{contactPersonNumber}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "phone",
        headerName: "Phone",
        width: 100,
        filterable: true,
        sortable: false,
        valueGetter: (params) => {
          return (params.row?.phone || "N/A");
        },
        renderCell: (params) => {
          let phone = params.row.phone || "N/A";
          return (
            <Tooltip title={phone || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{phone}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "View",
        headerName: "View",
        minWidth: 100,
        filterable: false,
        sortable: false,
        renderCell: (params) => {
          return (
            <>
              <Tooltip>
                <span>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => handleOpenExpenseModal(params.row)}
                    sx={{ minWidth: "80px" }}
                  >
                    {"View"}
                  </Button>
                </span>
              </Tooltip>
              <Modal open={openExpenseViewModal} onClose={handleCloseExpenseViewModal}>
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "80%",
                    maxWidth: 900,
                    bgcolor: "white",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    maxHeight: "90%",
                    overflowY: "auto",
                  }}
                >
                  <Typography variant="h6" component="h2" style={{ textAlign: "center" }} sx={{ color: "black", fontSize: "16px", fontWeight: "600" }}>
                    Expense Details
                  </Typography>
                  <IconButton onClick={() => setOpenExpenseViewModal(false)} style={{ position: "absolute", top: 10, right: 10 }}>
                    <CloseOutlined />
                  </IconButton>
                  {/* <hr style={{ width: "100%", color:"black", fontWeight:"800" }} /> */}
                  <hr style={{ width: "100%", border: "none", borderTop: "2px solid #222", margin: "16px 0" }} />
                  <div>
                    <div className="row mb-3 mt-1">
                      <div className="col-md-6" sx={{ color: "black", }}>
                        <b> Transporter Name : </b> {expenseModalData?.transporter_name || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b> Email : </b>
                        {expenseModalData?.email || 'N/A'}
                      </div>
                    </div>

                    <div className="row mb-3 mt-1">
                      <div className="col-md-6">
                        <b> Contact Person Name : </b> {expenseModalData?.contact_person_name || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b> Contact Person Number : </b> {expenseModalData?.contact_person_number || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-3 mt-1">
                      <div className="col-md-6">
                        <b> Address : </b> {expenseModalData?.complete_address || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b> State : </b> {expenseModalData?.state || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-3 mt-1">
                      <div className="col-md-6">
                        <b> Pincode : </b> {expenseModalData?.pin_code || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b>GST : </b> {expenseModalData?.gst || "N/A"}
                      </div>
                    </div>


                    <div className="row mt-1 mb-3">
                      <div className="col-12">
                        <b>Serving States : </b>
                        {(() => {
                          let states = expenseModalData?.serving_states;
                          if (typeof states === "string" && states.startsWith("[")) {
                            try { states = JSON.parse(states); } catch { }
                          }
                          if (Array.isArray(states)) {
                            return states.join(", ");
                          }
                          if (typeof states === "string") {
                            return states;
                          }
                          return "N/A";
                        })()}
                      </div>
                    </div>
                    <div className="row mt-1 mb-3">
                      <div className="col-md-6">
                        <b>Created At : </b>
                        {expenseModalData?.createdAt
                          ? new Date(expenseModalData.createdAt).toLocaleString("en-IN", {
                            timeZone: "Asia/Kolkata",
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })
                          : "N/A"}
                      </div>
                    </div>
                  </div>
                  <Box mt={2} display="flex" justifyContent="flex-end">
                    <Button onClick={handleCloseExpenseViewModal} variant="contained" color="primary">
                      Close
                    </Button>
                  </Box>
                </Box>
              </Modal>
            </>
          );
        },
      },
      {
        field: "actions",
        headerName: "Actions",
        width: 150,
        filterable: false,
        sortable: false,
        disableExport: true,
        renderCell: (params) => {
          return (
            <>
              <Tooltip title={"Edit Transporter"}>
                <IconButton onClick={() => handleEdit(params.row)}>
                  <DriveFileRenameOutlineIcon sx={{ color: "black", fontSize: "22px", fontWeight: "500" }} />
                </IconButton>
              </Tooltip>
              <Tooltip title={"Delete Transporter"}>
                <IconButton onClick={() => deleteTransporter(params.row)}>
                  <DeleteIcon sx={{ color: "red", fontSize: "22px", fontWeight: "500" }} />
                </IconButton>
              </Tooltip>
            </>
          );
        },
      },
    ];

    return result;
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        {/* <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport
          csvOptions={{
            fileName: "export-transporters",
          }}
        /> */}
      </GridToolbarContainer>
    );
  }

  const renderContent = () => {
    return (
      <>
        <div className="d-flex justify-content-end align-items-center  py-2">
          <Typography variant="body1" v sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Select Page Size:&nbsp; </Typography>
          <Select
            value={paginationModel.pageSize}
            variant="outlined"
            size="small"
            onChange={(e) => { setPaginationModel({ ...paginationModel, pageSize: e.target.value }) }}
            sx={{ width: 90, fontSize: 13, fontWeight: "500" }}
          >
            {[10, 20, 30, 50, 100].map((role) => (
              <MenuItem key={role} value={role} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role}</MenuItem>
            ))}
          </Select>
        </div>
        <DataGridContainer>
          <DataGrid
            className="payrollGrid"
            density="compact"
            rows={accessChanges || []}
            columns={getTransporterColumns()}
            sx={{ color: "black", fontSize: "14px", fontWeight: "600" }}
            disableSelectionOnClick
            disableRowSelectionOnClick
            disableDensitySelector
            rowHeight={60}
            // initialState={{
            //   pagination: {
            //     paginationModel: {
            //       pageSize: 10,
            //     },
            //   },
            // }}
            filterMode="server"
            paginationModel={paginationModel}
            paginationMode="server"
            onPaginationModelChange={setPaginationModel}
            rowCount={rowCount}
            pageSizeOptions={[10]}
            components={{
              Toolbar: CustomToolbar,
            }}
          />
        </DataGridContainer>

      </>

    );
  };

  const addTransporter = () => {
    setTransporterModal(true);
  };

  return (
    <>
      <StaffEditorPageContainer>
        {loading && <OpaqueLoading />}
        <HeaderContainer>
          <div
            style={{
              width: "50%",
              display: "flex",
              flexDirection: "row",
              gap: "10px",
            }}
          ></div>
          { accessModulesData && accessModulesData[0]?.is_add?.toLowerCase() != "no" &&  <Stack spacing={1} direction={"row"}>

            <Button variant="contained" color="primary"
              onClick={selectedTab === 0 ? () => setBulkTransporter(true) : ""} sx={{ mr: 1, borderRadius: '10px' }}>
              {/* <Add sx={{ mr: 1 }} /> */}
              <DriveFolderUploadIcon sx={{ mr: 1 }} />
              {selectedTab === 0 ? "Bulk Add Transporter" : ""}
            </Button>

            <Button variant="contained" color="primary"
              onClick={selectedTab === 0 ? addTransporter : ""} sx={{ mr: 1, borderRadius: '10px' }}>
              <Add sx={{ mr: 1 }} />
              {selectedTab === 0 ? "Add transporter" : ""}
            </Button>

          </Stack>}
        </HeaderContainer>
        <TableContainer>{renderContent()}</TableContainer>
      </StaffEditorPageContainer>
      {transporterModal && (
        <AddTransporterModal
          onClose={() => setTransporterModal(false)}
          fetchData={() => getTransporters()}
        />
      )}

      {editTransporterModal && (
        <AddTransporterModal
          onClose={() => setEditTransporterModal(false)}
          fetchData={() => getTransporters()}
          props={dataModal}
        />
      )}

      {
        bulkTransporter && <BulkAddTransporter onClose={() => setBulkTransporter(false)} fetchData={() => getTransporters()} />
      }
    </>
  );
}
